// tslint:disable:max-line-length

import React from 'react';

export const ActionSave = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M12.1,0L16,3v13H0V0H12.1z M13,7H3v6h10V7z M11,1H3v4h8V1z M10,2v2H8V2H10z" />
    </svg>
  );
};
